// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class IEnvelopeResendRequest {
    static getAttributeTypeMap() {
        return IEnvelopeResendRequest.attributeTypeMap;
    }
}
IEnvelopeResendRequest.discriminator = undefined;
IEnvelopeResendRequest.additionalProperties = false;
IEnvelopeResendRequest.attributeTypeMap = [
    {
        "name": "accountId",
        "baseName": "accountId",
        "type": "number"
    },
    {
        "name": "envelopeId",
        "baseName": "envelopeId",
        "type": "string"
    },
];
//# sourceMappingURL=iEnvelopeResendRequest.js.map